"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequireSpringboardAccountPrompt = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var TelemetryContext_1 = require("../Telemetry/TelemetryContext");
var SpringboardContext_1 = require("./SpringboardContext");
var styles = __importStar(require("./RequireAccountPrompt.css"));
var RequireSpringboardAccountPrompt = function (_a) {
    var action = _a.action, deferredAction = _a.deferredAction;
    var origin;
    if (action === "contact owner") {
        origin = SpringboardContext_1.AuthenticationOrigin.ContactOwner;
    }
    else {
        origin = SpringboardContext_1.AuthenticationOrigin.SavePage;
    }
    var _b = (0, SpringboardContext_1.useSpringboardContext)(), getAuthenticationUrl = _b.getAuthenticationUrl, pageUrl = _b.pageUrl;
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var loginUrl = getAuthenticationUrl("login", origin, pageUrl);
    var signupUrl = getAuthenticationUrl("signup", origin, pageUrl);
    var heading = action === "save page"
        ? "Create a free Qwilr Springboard account to save your pages all in one place"
        : "Verify your identity to contact the page owner";
    (0, react_1.useEffect)(function () {
        track("Saw Consumer Signup Modal", { origin: action });
    }, []);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(styles.createAccountPopover) },
        react_1.default.createElement(kaleidoscope_1.RainbowBar, { size: "small" }),
        react_1.default.createElement("img", { className: styles.createAccountPopoverImage, src: "/Public/Assets/Images/springboard-signup.jpg" }),
        react_1.default.createElement("div", { className: styles.createAccountPopoverContent },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "4", align: "center" }, heading),
            react_1.default.createElement(kaleidoscope_1.Button, { className: styles.createAccountPopoverButton, href: function () { return signupUrl; }, onClick: deferredAction }, "Create account"),
            react_1.default.createElement(kaleidoscope_1.Text, null,
                "Already have an account?",
                " ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: loginUrl, onClick: deferredAction }, "Log in")))));
};
exports.RequireSpringboardAccountPrompt = RequireSpringboardAccountPrompt;
